import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface GlobalSoundState {
  isSoundEnabled: boolean;
  masterVolume: number;
  toggleSound: () => void;
  setVolume: (volume: number) => void;
}

export const useGlobalSound = create<GlobalSoundState>()(
  persist(
    (set) => ({
      isSoundEnabled: true,
      masterVolume: 0.7,
      toggleSound: () => set((state) => ({ 
        isSoundEnabled: !state.isSoundEnabled 
      })),
      setVolume: (volume: number) => set({ masterVolume: volume }),
    }),
    {
      name: 'admin-sound-settings',
    }
  )
);